import {
  FETCH_ADMIN_LINKS,
  ADD_USER_LINK,
  FETCH_USER_LINKS,
  DELETE_USER_LINK,
  UPDATE_USER_LINK
} from './constants'

export const fetchAdminLinks = {
  request: () => ({ type: FETCH_ADMIN_LINKS.REQUEST }),
  success: (links) => ({ type: FETCH_ADMIN_LINKS.SUCCESS, links })
}
export const addUserLink = {
  request: (data) => ({ type: ADD_USER_LINK.REQUEST, data }),
  success: (links) => ({ type: ADD_USER_LINK.SUCCESS, links })
}
export const updateUserLink = {
  request: (data) => ({ type: UPDATE_USER_LINK.REQUEST, data }),
  success: (links) => ({ type: UPDATE_USER_LINK.SUCCESS, links })
}
export const deleteUserLink = {
  request: (data) => ({ type: DELETE_USER_LINK.REQUEST, data }),
  success: (links) => ({ type: DELETE_USER_LINK.SUCCESS, links })
}
export const fetchUserLinks = {
  request: (user) => ({ type: FETCH_USER_LINKS.REQUEST, user }),
  success: (links) => ({ type: FETCH_USER_LINKS.SUCCESS, links })
}
